import React from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const WidgetPageWrapper = ({
  title,
  keepFooterVisable,
  loading,
  children,
  ...rest
}) => {
  return (
    <React.Fragment>
      <Helmet defer={false} title={title} />

      <Row>
        <Col>
          <h1 className="mb-3">
            {title}
            {loading && (
              <Spinner
                animation="border"
                variant="primary"
                size="sm"
                className="p-0 m-0"
              />
            )}
          </h1>
          {keepFooterVisable ? (
            <div
              className="p-1"
              style={{
                height: "calc(100vh - 240px)",
                minHeight: "240px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {children}
            </div>
          ) : (
            <React.Fragment>
              <Card className="m-0 p-3">{children}</Card>
            </React.Fragment>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default WidgetPageWrapper;
